<div class="conflict-check-container p-16">
  <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(4,minmax(0,1fr))']">
    <kendo-gridlayout-item [colSpan]="3">
      <div class="address-search-wrapper kendo-field width-100">
        <app-address-search-input [label]="'Address / ZIP Search'" [placeholder]="'Address Search'" [loadAPI]="true"
          [(ngModel)]="proximityAddress" [ngModelOptions]="{ standalone: true }" (addressSelected)="onAddressSelected($event)">
        </app-address-search-input>
      </div>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item class="filter-actions" style="display: flex; align-items: center; gap: 16px; margin-top: 16px;">
      <kendo-button kendoButton themeColor="primary" fillMode="solid" size="medium" (click)="onApply()">Apply Filters</kendo-button>
      <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium" (click)="onClear()">Clear</kendo-button>
    </kendo-gridlayout-item>
  </kendo-gridlayout>

  <div *ngIf="tableInput" class="results-wrapper">
    <app-investigation-loss-address-check-table #lossAddressTable [input]="tableInput" [showActionColumn]="false"
      (markersChanged)="markers = $event" (rowClick)="selectedInvestigationId = $event">
    </app-investigation-loss-address-check-table>
    <div class="centered-map-container mt-16" style="height: 400px; position: relative;">
      <app-google-map [lon]="tableInput.LossAddress.longitude" [lat]="tableInput.LossAddress.latitude"
        [markers]="markers" [selectedLocation]="selectedInvestigationId"
        (iconClick)="lossAddressTable.selectedInvestigationId = $event"></app-google-map>
    </div>
  </div>
</div>
